// @flow
import storage from 'local-storage-fallback';

const AccessTokenKey = 'access_token';

const LocalStorageService = {
  getToken: (): ?string => storage.getItem(AccessTokenKey),
  setToken: (token: string) => storage.setItem(AccessTokenKey, token),
  removeToken: (): void => storage.removeItem(AccessTokenKey)
};

export default LocalStorageService;
